// extracted by mini-css-extract-plugin
module.exports = {"container":"Cu6fU","tooltip":"_2MqAA"};